import { sel } from "../selectors";
import { DEFAULT_STAGE_VIEWPORT, Scene } from "./types";

// Lesson: Writing and editing → Snippets.
// Fixture: `writingTools` (one department snippet, one of the officer's own).
// The scene inserts the Miranda advisement, creates a "Witness contact"
// snippet with two placeholders, inserts it, and fills the placeholders in.
const CASE_ID = "c0000000-0000-4000-8000-000000000201";
const TAB = `${sel("editorSidebarTabs")} button[title="Snippets"]`;
const DEPT = `${sel("snippetItem")}[data-snippet-scope="department"]`;
const MINE = `${sel("snippetItem")}[data-snippet-scope="mine"]`;
const MENU_ITEM = (scope: string, n: number) => `${sel("snippetItem")}[data-snippet-scope="${scope}"] ul li:nth-child(${n}) p`;
const PLACEHOLDER = `${sel("editorNarrative")} .replace-text`;

const scene: Scene = {
  id: "snippets",
  title: "Snippets",
  startRoute: `/cases/${CASE_ID}`,
  fixture: "writingTools",
  viewport: DEFAULT_STAGE_VIEWPORT,
  steps: [
    {
      id: "intro",
      narration:
        "Snippets are text you type on every report, like Miranda or consent language. Open the Snippets tab. Department Snippets come from your admin. My Snippets are yours.",
      actions: [
        { type: "waitFor", target: sel("editorSidebarTabs") },
        { type: "wait", ms: 1200 },
        { type: "click", target: TAB },
        { type: "waitFor", target: DEPT },
        { type: "wait", ms: 3500 },
        { type: "spotlight", target: DEPT },
        { type: "wait", ms: 2000 },
        { type: "spotlight", target: MINE },
        { type: "wait", ms: 2000 },
        { type: "spotlight", target: null },
      ],
    },
    {
      id: "insert",
      narration:
        "Click a snippet and choose Add to cursor, Add to top of report, or Add to end of report. I'll add the Miranda advisement to the end.",
      actions: [
        { type: "click", target: `${DEPT} > div` },
        { type: "wait", ms: 4600 },
        { type: "click", target: MENU_ITEM("department", 3) },
        { type: "wait", ms: 1000 },
      ],
    },
    {
      id: "create",
      narration: "To make your own, click Add Snippet, then fill in the Title and the Content.",
      actions: [
        { type: "moveTo", target: sel("snippetAdd") },
        { type: "wait", ms: 500 },
        { type: "click", target: sel("snippetAdd") },
        { type: "waitFor", target: `${sel("snippetDialog")} input[type="text"]` },
        { type: "wait", ms: 1100 },
        { type: "type", target: `${sel("snippetDialog")} input[type="text"]`, text: "Witness contact", cps: 12 },
        { type: "wait", ms: 400 },
      ],
    },
    {
      id: "placeholders",
      narration:
        "In the content, wrap anything that changes per report in double braces, like Witness Name. Then save.",
      actions: [
        {
          type: "type",
          target: `${sel("snippetDialog")} textarea`,
          text: "I spoke with witness {{Witness Name}}, who can be reached at {{Phone Number}}.",
          cps: 22,
        },
        { type: "wait", ms: 1300 },
        { type: "click", target: sel("snippetSave") },
        { type: "waitFor", target: MINE },
        { type: "wait", ms: 200 },
      ],
    },
    {
      id: "use",
      narration: "Insert it the same way. Then click each placeholder in the narrative and fill it in, like the witness's name and phone number.",
      actions: [
        { type: "click", target: `${sel("snippetItem")}[data-snippet-scope="mine"]:last-of-type > div` },
        { type: "wait", ms: 600 },
        { type: "click", target: `${sel("snippetItem")}[data-snippet-scope="mine"]:last-of-type ul li:nth-child(3) p` },
        { type: "waitFor", target: PLACEHOLDER },
        { type: "moveTo", target: PLACEHOLDER },
        { type: "waitFor", target: `${sel("editorNarrative")} [contenteditable="true"]`, timeoutMs: 5000 },
        { type: "wait", ms: 1200 },
        { type: "typeOver", target: PLACEHOLDER, text: "Dana Whitfield", cps: 14 },
        { type: "wait", ms: 300 },
        { type: "typeOver", target: PLACEHOLDER, text: "555-0142", cps: 12 },
        { type: "wait", ms: 300 },
      ],
    },
    {
      id: "outro",
      narration:
        "Department Snippets are read-only for you, so ask your admin to change one. And if you add the same text to every report, put it in a template footer instead.",
      actions: [
        { type: "scrollIntoView", target: DEPT },
        { type: "spotlight", target: DEPT },
        { type: "wait", ms: 4500 },
        { type: "spotlight", target: null },
      ],
    },
  ],
};

export default scene;
